import chapter1 from "./images/chapter1.jpg";
import chapter2 from "./images/chapter2.jpg";
import chapter3 from "./images/chapter3.jpg";
import chapter4 from "./images/chapter4.jpg";
import chapter6 from "./images/chapter6.jpg";
import chapter7 from "./images/chapter7.jpg";
import fs from "./images/fs.gif";


const config = {
    style: 'mapbox://styles/elolelo/ckeakrhvx0dmx19mxjl4w45zs',
    accessToken: 'pk.eyJ1IjoiZWxvbGVsbyIsImEiOiJja2ExMW5zbmQwbHhrM2ZydHRoczRvd2FyIn0.0olVRy1noRHuGDdb6yEYrg',
    showMarkers: true,
    theme: 'dark',
    alignment: 'center',
    title: "South Africa's Health facilities data ",
    subtitle: 'Data collected until October 2020, about health facilities in South Africa,  is shown to understand the scale of COVID-19 infections.',
    byline: 'By Nompumelelo Mtsweni ',
   
   // language:'Choose the language [ENG, ZULU, AFRI]',
    footer: 'Acknowledgements: The Office of Astronomy for Development (OAD), Anelda Van der Walt, Prof. Vukosi Marivate, Herkulaas MvE Combrink, Dr. Andy South, Nelisiwe Dlamini,  DSFSI team, and Afrimapr team.',
    chapters: [
        {
            id: 'slug-style-id',  // chapter 1 - SA latlong
            title: 'This data project started with identifying health facilities around where we live - using a Geolocation API and Google Maps( as shown in the map below). ',
            image: chapter1,
            description: 'This map shows not only the health facilites near you but an estimate of bed capacities (based on the data collected in 2018) .',
            link: `https://dsfsi.github.io/healthfacilitymap/`, 
            dataset:`https://github.com/dsfsi/covid19za/blob/master/data/health_system_za_hospitals_v1.csv`,
            blog:`https://dsfsi.github.io/blog/mapping-healthsystem/`,
            location: {
                center: [24.6727135 ,-28.4792625],
                zoom: 5.0,
                pitch: 90,
                bearing: 0
                // add the SA coordinates for zooming
            },
            onChapterEnter: [
                {
                   layer: 'settlement-subdivision-label',
                   opacity: 1
                 },
                 
            ],
            onChapterExit: [
                // {
                //     layer: 'layer-name',
                //     opacity: 0
                // }
            ]
        },
        {
            id: 'identifier1',   // chapter 2 - JHB lat long
            title: '2.In general, where are they and what capacities do they have?',
            image: chapter2,  
            description: `Description: The R-map showing facility types and some of the resources they have`,
            link: `https://andysouth.shinyapps.io/hosp-viewer-SA-v02/`, 
            dataset:`https://github.com/dsfsi/covid19za/blob/master/data/health_system_za_hospitals_v1.csv`,
            blog:`https://afrimapr.github.io/afrimapr.website/blog/2020/visualisation-to-improve-data-quality/`,
            location: {
                center: [24.6727135 ,-28.4792625],
                zoom: 5.0,
                pitch: 90,
                bearing: 0
            },
            onChapterEnter: [],
            onChapterExit: []
        },
        {
            id: 'identifier2',  // chapter 3  city of cape town lat long
            title: '3.In general, how resourced are the health facilies in each district',
            image: chapter3,
            description: 'Chapter about numbe of health facilities per district.',
            link: `https://elolelo.github.io/built-final/map1/`, 
            dataset:`https://github.com/dsfsi/covid19za/tree/master/data/Other_health_facilities`,
            location: {
                center: [24.6727135 ,-28.4792625],
                zoom: 5.0,
                pitch: 90,
                bearing: 0
            },
            onChapterEnter: [],
            onChapterExit: []
        },
        {
            id: 'identifier3',  // Chapter 4 Eastern Cape lat long
            title: '4.Field hospitals created and build as a response to Covid-19',
            image: chapter4,
            description: 'Chapter about field hospitals',
            link: `#`, // explore the map 
            dataset:`https://github.com/dsfsi/covid19za/blob/master/data/health_system_za_field_hospitals.csv`,
            location: {
                center: [24.6727135 ,-28.4792625],
                zoom: 5.0,
                pitch: 90,
                bearing: 0
            },
            onChapterEnter: [],
            onChapterExit: []
        },
        {
            id: 'identifier4',   // Chapter 6 districts  with the most in the past
            title: '5.Occupancy rates of last year compare to this years',
            image: chapter6,
            description: 'Chapter about last years  bed occupancy rates',
            dataset:`#`,
            location: {
                center: [24.6727135 ,-28.4792625],
                zoom: 5.0,
                pitch: 90,
                bearing: 0
            },
            onChapterEnter: [],
            onChapterExit: []
        },
        {
            id: 'identifier51',   //province # 1
            title: 'Covid-19 Cases in the Western Cape  ',
            image:fs,
            description: 'Data from 2020 - 2021, May',
            dataset:`Postive cases: 292,992, Deaths:11,793 , Recoveries:277,881 `,
            location: {
                center: [21.8569,-33.2278] ,   // 33.2278° S, 21.8569° E
                zoom: 7.0,
                pitch: 60,
                bearing: 5
            },
            onChapterEnter: [],
            onChapterExit: []
        },
        {
            id: 'identifier52',   //province # 2
            title: 'Covid-19 Cases in the Northern Cape',
            description: 'Postive cases:49,363 , Deaths:1,076 , Recoveries:40,875 ',
            dataset:`#`,
            location: {
                center: [21.8569,-29.0467] ,   // 29.0467° S, 21.8569° E
                zoom: 7.0,
                pitch: 60,
                bearing: 10
            },
            onChapterEnter: [],
            onChapterExit: []
        },
        {
            id: 'identifier53',   //province # 3
            title: 'Covid-19 Cases in the North West',
            description: 'Postive cases:75,102 , Deaths:1,889 , Recoveries:67,386 ',
            dataset:`#`,
            location: {
                center: [25.2838 ,-26.6639] ,   // 26.6639° S, 25.2838° E
                zoom: 8,
                pitch: 60,
                bearing: 10
            },
            onChapterEnter: [],
            onChapterExit: []
        },
        {
            id: 'identifier54',   //province # 4
            title: 'Covid-19 Cases in the Free State',
            description: 'Postive cases:100,135 , Deaths:4,318 , Recoveries:88,069 ',
            dataset:`#`,
            location: {
                center: [26.7968 ,-28.4541] ,  // 28.4541° S, 26.7968° E
                zoom: 7.0,  
                pitch: 60,
                bearing: 10
            },
            onChapterEnter: [],
            onChapterExit: []
        },
        {
            id: 'identifier55',   //province #  5
            title: 'Covid-19 Cases in Eastern Cape',
            description: 'Postive cases:197,588 , Deaths:11,657 , Recoveries:185,089 ',    // 32.2968° S, 26.4194° E
            dataset:`#`,
            location: {  
                center: [26.4194 ,-32.2968] ,
                zoom: 10.0,
                pitch: 60,
                bearing: 10
            },
            onChapterEnter: [],
            onChapterExit: []
        },

        {
            id: 'identifier56',   //province # 6
            title: 'Covid-19 Cases in Mpumalanga',
            description: 'Postive cases: 82,057, Deaths:1,444 , Recoveries:78,911 ',
            dataset:`#`,
            location: {
                center: [30.5279 ,-25.5653] ,  //25.5653° S, 30.5279° E
                zoom: 10.0,
                pitch: 600,
                bearing: 5
            },
            onChapterEnter: [],
            onChapterExit: []
        },

        {
            id: 'identifier57',   //province # 7
            title: 'Covid-19 Cases in Gauteng',
            description: 'Postive cases:452,590 , Deaths:11,164 , Recoveries:426,525 ',
            dataset:`#`,
            location: {
                center: [28.1123, -26.2708 ] , //26.2708° S, 28.1123° E
                zoom: 10.0,
                pitch: 60,
                bearing: 10
            },
            onChapterEnter: [],
            onChapterExit: []
        },

        {
            id: 'identifier58',   //province # 8
            title: 'Covid-19 Cases in Limpopo',
            description: 'Postive cases:65,188 , Deaths:2,446  , Recoveries: 62,093',
            dataset:`#`,
            location: {
                center: [29.4179 ,-23.4013] ,  //23.4013° S, 29.4179° E
                zoom: 10.0,
                pitch: 60,
                bearing: 5
            },
            onChapterEnter: [],
            onChapterExit: []
        },
        {
            id: 'identifier59',   //province # 9
            title: 'Covid-19 Cases in KwaZulu Natal',
            description: 'KZN Cases :339,536. Recoveries: 324,691 and Deaths: 10,506',
            dataset:`#`,
            location: {
                center: [30.8958 ,-28.5306] ,  // 28.5306° S, 30.8958° E
                zoom: 10,
                pitch: 60,
                bearing: 5
            },
            onChapterEnter: [],
            onChapterExit: []
        },
        {
            id: 'identifier6',  // Chapter 7 back to SA lat long
            title: '7.More details about covid-19 data',
            image: chapter7,
            description: 'In South Africa, there has been a total of  1,654,511 cases of Covid-19 positive. And 56,293 Covid-19 related deaths and 1,551,520 recoveries. ',
            location: {
                center: [24.6727135 ,-28.4792625],
                zoom: 5.0,
                pitch: 90,
                bearing: 0
            },
            onChapterEnter: [],
            onChapterExit: []
        }
    ]
};

export default config;
